import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IPar, Par } from './Par'

export class ParMapper implements ICollectionMapper<Par> {
  map(data: IPar): Par {
    const par = new Par(data.restaurantCompanyId, data.priceListEntryId, data.quantity)
    par.id = data.id
    par.quantityType = data.quantityType
    par.location = data.location ? data.location : "Main Bar"
    return par
  }

  serialize(object: Par): IPar {
    return JSON.parse(JSON.stringify(object))
  }
}
